import React from 'react';
import { Form, Select, Button, Modal, Row, Col, Spin, Icon } from 'antd';
import { openNotification } from '../../util/notificaciones';
import SegmentosPVRequest from '../../services/SegmentosPV';
import BaseComponent from '../Common/BaseComponent';



const { Option } = Select;

/**
 * Clase para ver el formulario de segmento
 */
class FormSegementoPV extends BaseComponent {
    state = {
        bloquearBotones: false,
        cargando: false,
        mostrarModalConfirm: false,
        SegmentoPVList: undefined,
        SegmentoPVListSelected: undefined,
    }

    componentDidMount = () => {
        let state = { ...this.state }

        SegmentosPVRequest.ListarSegmento()
            .then(response => {
                let SegmentoPVList = []
                response.data.forEach(item => {
                    SegmentoPVList.push({ item })
                })

                state.SegmentoPVList = SegmentoPVList;
                this.setState(state)
            })
            .catch(err => {
                this.setState({ loading: false })
                openNotification("Ocurrió un error al cargar los segmentos", "Error", false);
            })
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de segmentos
     */
    handleCancel = () => {
        let state = { ...this.state }
        this.props.cancel(false);
        state.SegmentoPVListSelected = [];
        this.setState(state)

    }

    actualizarLista = () => {
        let state = { ...this.state }
        state.cargando = false;
        state.SegmentoPVListSelected = [];
        state.bloquearBotones = false;
        SegmentosPVRequest.ListarSegmento()
            .then(response => {
                let SegmentoPVList = []
                response.data.forEach(item => {
                    SegmentoPVList.push({ item })
                })

                state.SegmentoPVList = SegmentoPVList;
                this.setState(state)
            })
            .catch(err => {
                this.setState({ loading: false })
                openNotification("Ocurrió un error al cargar los segmentos", "Error", false);
            })
    }

    /**
     * Funcion para validar que Segmento se selecciono
     */
    onChangeSegmentoSelected = (value) => {
        let state = { ...this.state }
        if (value === undefined) {
            state.SegmentoPVListSelected = undefined;

        } else {
            state.SegmentoPVListSelected = value
        }
        this.setState(state)
    }

    /**
     * Función que se ejecuta cuando se da clic 
     * en guardar la edición del segmento
     * @param: nada.
     * @return: nada.
     */
    guardarSegmento = () => {
        let state = { ...this.state };
        this.props.form.validateFields((err, values) => {
            if (!err) {
                values.segmento = state.SegmentoPVListSelected
                let ruta = SegmentosPVRequest.NuevoSegmento(values)
                state.bloquearBotones = true;
                state.cargando = true;
                this.setState(state, () => {
                    ruta.then(response => {
                        openNotification(response?.data?.cuerpo, response?.data?.titulo, true)
                        this.props.cancel(true);
                        this.actualizarLista();
                        this.setState(state)

                    }).catch(err => {
                        this.setState({ cargando: false, bloquearBotones: false })
                        openNotification("Seleccione un segmento para", "Aviso", false)
                    })
                })
            }
        })
    }

    render() {
        return (
            <div>
                <Modal
                    title={`Nuevo segmento punto de venta`}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    width={this.state.isPos ? "80%" : "30%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-segmento"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={'btnVerCrearGuardar'}
                                key="submit"
                                id="boton-guardar-form-segmento_pv"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={() => { this.guardarSegmento() }}>
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form>
                            <Row gutter={24}>
                                <Col span={24}>

                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={true}
                                        showSearch
                                        defaultValue={null}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        value={this.state.SegmentoPVListSelected}
                                        onChange={this.onChangeSegmentoSelected}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {

                                            this.state.SegmentoPVList?.length > 0 &&
                                            this.state.SegmentoPVList?.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.item.id}
                                                        value={obj.item.id}>
                                                        {obj.item.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
                <Modal
                    title={<p style={{ textAlign: "center", marginBottom: 0 }}>Confirmar</p>}
                    onCancel={() => {
                        this.setState({ mostrarModalConfirm: false })
                    }}
                    centered={true}
                    visible={this.state.mostrarModalConfirm}
                    maskClosable={false}
                    footer={[
                        <Button
                            id='regresar-boton-confirmar-editar-segmento_pv'
                            className="btnCancelar"
                            key="back"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarModalConfirm = false;
                                this.setState(state);
                            }}>
                            Regresar
                        </Button>,
                        <Button
                            id='guardar-boton-confirmar-editar-segmento_pv'
                            className="btnVerCrearGuardar"
                            key="submit"
                            type="primary"
                            onClick={() => {
                                let state = { ...this.state };
                                state.mostrarModalConfirm = false;
                                this.setState(state, this.guardarSegmento);
                            }}
                        >
                            Guardar
                        </Button>
                    ]}
                >
                    <p><b>¿Está seguro de editar la configuración del segmento?</b></p>
                </Modal>
            </div>
        )
    }

}

export default Form.create()(FormSegementoPV);